import { memo, useEffect, useState } from "react";
import clsx from "clsx";
import { take, takeRight } from "lodash";
import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {
  ERROR_DRIVERLESS_ROUTES,
  WARNING_DRIVERLESS_ROUTES,
} from "../../../consts/strings";
import { PLAN_TYPE_NAMES } from "../../../consts/planTypes";

const useStyles = makeStyles({
  listItem: {
    fontSize: "12px",
    lineHeight: "14px",
    margin: "10px 0",
  },
  additionalItems: {
    color: "rgba(0, 0, 0, 0.5)",
  },
  planTypeHeader: {
    marginTop: "20px",
    marginBottom: "-2px",
  },
});

export const DriverlessRoutesContent = memo(({ driverlessRoutes, error }) => {
  const styles = useStyles();
  if (!driverlessRoutes) driverlessRoutes = {};

  const [firstRoutes, setFirstRoutes] = useState({});
  const [remainingRoutes, setRemainingRoutes] = useState({});

  useEffect(() => {
    if (!driverlessRoutes) return;

    const driverlessRoutesTypes = Object.values(driverlessRoutes).filter(
      ({ length }) => !!length
    ).length;
    let chunkSize = 6;
    if (driverlessRoutesTypes > 2) chunkSize = 2;
    else if (driverlessRoutesTypes > 1) chunkSize = 3;

    const { first, remaining } = Object.keys(driverlessRoutes).reduce(
      (acc, type) => {
        const typeDriverlessRoutes = driverlessRoutes[type];
        acc.first[type] = take(typeDriverlessRoutes, chunkSize);
        acc.remaining[type] = takeRight(
          typeDriverlessRoutes,
          typeDriverlessRoutes.length - chunkSize
        );
        return acc;
      },
      { first: {}, remaining: {} }
    );

    setFirstRoutes(first);
    setRemainingRoutes(remaining);
  }, [driverlessRoutes]);

  return (
    <>
      <Typography>
        {error ? ERROR_DRIVERLESS_ROUTES : WARNING_DRIVERLESS_ROUTES}
      </Typography>
      {Object.keys(driverlessRoutes).map((type) => (
        <>
          {firstRoutes?.[type]?.length > 0 && (
            <div className={styles.planTypeHeader}>{PLAN_TYPE_NAMES[type]}</div>
          )}
          {firstRoutes?.[type]?.map((route, index) => (
            <div key={index}>
              <div className={styles.listItem}>{route}</div>
            </div>
          ))}
          {remainingRoutes?.[type]?.length > 0 && (
            <div className={clsx(styles.listItem, styles.additionalItems)}>
              +{remainingRoutes[type].length} Other Routes
            </div>
          )}
        </>
      ))}
    </>
  );
});
